export default {
    header: 'ตั้งค่าเวลาทำงาน',
    workday: 'วันทำงาน',
    specialWorkday: 'วันทำงานพิเศษ',
    holiday: 'วันหยุด'
}
